<template>
    <div class="video-box" :class="{ header: is_header, 'video-box--full': fullWidth }">
        <div v-if="!isPlaying" @click.stop="playVideo" class="video-box__cover">
            <van-image :src="thumb" fit="cover" class="thumb" />
            <img src="@/assets/icon/video_100.png" class="play" />
        </div>
        <video v-else ref="video" class="video-player" :src="url" :poster="thumb" controls playsinline
            webkit-playsinline="true" x5-playsinline="true" x5-video-player-type="h5" preload="metadata"
            @click.stop></video>
    </div>
</template>
<script>
export default {
    name: 'VideoBox',
    props: {
        is_header: {
            type: Boolean,
            default: false
        },
        fullWidth: {
            type: Boolean,
            default: false
        },
        thumb: {
            type: String,
            default: ''
        },
        url: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isPlaying: false,
        }
    },
    methods: {
        playVideo() {
            if (!this.url) {
                return
            }
            this.isPlaying = true
            this.$nextTick(() => {
                const video = this.$refs.video
                if (video && typeof video.play === 'function') {
                    video.play().catch(() => { })
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
    @return $px / 75+rem;
}

.video-box {
    position: relative;
    width: rem(300);
    height: rem(300);
}

.video-box--full {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
}

header {
    position: relative;
    width: 100%;
    height: rem(300);
}

.thumb {
    width: 100%;
    height: 100%;
    background-color: #262626;
}

.play {
    position: absolute;
    width: rem(100);
    height: rem(100);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 1;
    opacity: 0.9;
}

.header {
    width: 100%;
    height: rem(320);
}

.video-box__cover {
    position: relative;
    width: 100%;
    height: 100%;
}

.video-player {
    width: 100%;
    height: 100%;
    display: block;
    background-color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoBox.vue